module.exports = __webpack_public_path__ + "img/food3.a007a3c3.png";